import React, { useContext } from "react";
import { SocialButton } from "@monorepo/components";
import { SignAuth0Context } from "../../Auth0Context";

import "./GoogleButton.scss";
import logo from "../google_logo.svg";

import { pushDataToSegment, saveLastAttemptInfo } from "../../segmentData";
import {
  SIGN_IN_ATTEMPT,
  ACCOUNT_CREATION_ATTEMPT,
  SIGN_IN_SUCCESS,
  ACCOUNT_CREATION_SUCCESS,
  ACCOUNT_CREATION_PAGE,
  SIGN_IN_PAGE
} from "../../constant";

interface GoogleButtonProps {
  id?: string;
  title: string;
  imgAlt: string;
  wrappedProps?: any;
}

export const GoogleButtonControl: React.FunctionComponent<GoogleButtonProps> = (
  props: GoogleButtonProps
) => {
  const { id, title, wrappedProps, imgAlt } = props;

  const auth0 = useContext(SignAuth0Context);

  const onGooglePressed = (): void => {
    saveLastAttemptInfo({ label: "Google" });
    if (id && id.includes("signUp")) {
      pushDataToSegment(ACCOUNT_CREATION_ATTEMPT, false, { label: "Google", pageName: ACCOUNT_CREATION_PAGE });
    } else {
      pushDataToSegment(SIGN_IN_ATTEMPT, false, { label: "Google", pageName: SIGN_IN_PAGE });
    }

    auth0.authenticateGoogle();

    if (id && id.includes("signUp")) {
      // we would always send succeeded (there’s no chance of failure, it’s just redirecting the user away)
      pushDataToSegment(ACCOUNT_CREATION_SUCCESS, false, { label: "Google", pageName: ACCOUNT_CREATION_PAGE });
    } else {
      pushDataToSegment(SIGN_IN_SUCCESS, false, { label: "Google", pageName: SIGN_IN_PAGE });
    }
  };

  return (
    <SocialButton
      id={id === undefined ? "google" : id}
      wrappedProps={wrappedProps}
      title={title}
      imgSrc={logo}
      imgAlt={imgAlt}
      onPressed={onGooglePressed}
    />
  );
};

const GoogleButton: React.FunctionComponent<GoogleButtonProps> = React.memo(
  GoogleButtonControl
);
export default GoogleButton;
